import { apiBaseURL } from '@api/setup';
import React, { FC, useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import DescopeWc from '@descope/web-component';

// we don't want Descope WC preview to persist the tokens so a successful
// login won't store tokens in browser storage
DescopeWc.sdkConfigOverrides = { persistTokens: false };

interface IDescopeFlowPreviewProps {
	projectId: string;
	flowId: string;
	onSuccess: (e: any) => void;
	onError: () => void;
}

const DescopeFlowPreview: FC<IDescopeFlowPreviewProps> = ({
	projectId,
	flowId,
	onSuccess,
	onError
}) => {
	const innerRef = useRef<any>();

	useEffect(() => {
		const ele = innerRef?.current;
		ele?.addEventListener('success', onSuccess);
		ele?.addEventListener('error', onError);

		return () => {
			ele?.removeEventListener('success', onSuccess);
			ele?.removeEventListener('error', onError);
		};
	}, [innerRef, onSuccess, onError]);

	return (
		// wrap in form so descope wc wont add form itself,
		// this is done in order to avoid issue when unmounting component
		<form>
			<descope-wc
				ref={innerRef}
				project-id={projectId}
				base-url={apiBaseURL()}
				flow-id={flowId}
			/>
		</form>
	);
};

export default DescopeFlowPreview;
